// extracted by mini-css-extract-plugin
module.exports = {"container":"portfolio-photo-module--container--2GbF0","overlay":"portfolio-photo-module--overlay--2zxLn"};